__turbopack_context__.v({
  "className": "alegreya_sans_41fb74a4-module__ki8nWa__className",
  "variable": "alegreya_sans_41fb74a4-module__ki8nWa__variable",
});
